import React from "react"
import { Flex, Form, InputNumber, Switch, Tooltip } from "antd"
import { InfoCircleOutlined } from "@ant-design/icons"
import { useWatch } from "antd/es/form/Form"
import { Card } from "ui/Card"
import { Text } from "ui/Typography"
import styles from "./AvailabilityDisplay.module.css"

export const AvailabilityDisplay = () => {
  const isEnabled = useWatch("low_availability_enabled")

  return (
    <Card title={"Availability Display"} className="mb-3xl">
      <Flex vertical gap={16}>
        <Flex align="center" gap={8}>
          <Form.Item name="low_availability_enabled" valuePropName="checked" initialValue={true} noStyle>
            <Switch />
          </Form.Item>
          <Text>{"Low availability indicator"}</Text>
          <Tooltip title={"Shows a low availability warning to guests when remaining slots are at or below the threshold"}>
            <InfoCircleOutlined className={styles.infoIcon} />
          </Tooltip>
        </Flex>

        {isEnabled && (
          <Flex align="center" gap={8}>
            <Text>{"Show when remaining slots ≤"}</Text>
            <Form.Item name="low_availability_threshold" initialValue={1} noStyle>
              <InputNumber min={1} className={styles.thresholdInput} size="middle" />
            </Form.Item>
          </Flex>
        )}
      </Flex>
    </Card>
  )
}
